import { useTranslation } from 'react-i18next';
import InformationTooltip from 'components/atoms/information-tooltip';
import InformationRoundedIcon from 'components/atoms/icons/information-rounded';

import s from './styles.module.scss';

import type { ICondition } from 'infrastructure/interfaces';
import type { FC } from 'react';

interface ConditionsRowProps {
  conditions?: ICondition[];
}

const ConditionsRow: FC<ConditionsRowProps> = ({ conditions }) => {
  const { t } = useTranslation();

  const icdCodes = conditions
    ?.map((condition) => condition.icdCode.code)
    .join('; ');

  const tooltipContent = conditions?.map((condition) => (
    <div key={condition.icdCode.code}>
      <p style={{ fontWeight: 700 }}>{condition.icdCode.code}</p>
      <p>{condition.description}</p>
    </div>
  ));

  return (
    <div className={s.wrapper}>
      {icdCodes && (
        <>
          <div className={s['conditions-wrapper']} data-cy="conditions-wrapper">
            <p className={s.label} data-cy="conditions-label">
              {t('labels.conditions')}:{' '}
            </p>
            <p className={s['icd-codes']} data-cy="conditions-value">
              {icdCodes}
            </p>
          </div>
          <InformationTooltip
            content={tooltipContent}
            contentWrapperClassName={s['information-content-wrapper']}
            contentClassName={s['information-content']}
            icon={
              <InformationRoundedIcon
                width={24}
                height={24}
                className={s.icon}
              />
            }
          />
        </>
      )}
    </div>
  );
};
export default ConditionsRow;
